import React, { PropTypes } from 'react';

/**
 * Activity Item Title
 */
const ItemTitle = (props) => {
  if (!props.title) return <span />;

  let dash = '';

  if (`${props.title}`.length > 1) dash = ' | ';

  return (
    <span className="af-list-item-title">
      <span> </span>
      {dash}
      {props.title}
    </span>
  );
};

ItemTitle.propTypes = {
  title: PropTypes.string,
};

ItemTitle.defaultProps = {
  title: '',
};

export default ItemTitle;
